'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var UnorderedList = function UnorderedList(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 30 30' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13 23h10v-2H13v2zm-5 0h3v-3H8v3zm0-6h3v-3H8v3zm0-6h3V8H8v3zm5 0h10V9H13v2zm0 6h10v-2H13v2z' })
    )
  );
};
/*eslint-enable */

exports.default = UnorderedList;
//# sourceMappingURL=UnorderedList.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/UnorderedList.js